import { Validators } from '@angular/forms';
import { TravelRequestStatus } from '@models/request';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { maxLengthValidator } from '@utility/utility.validators';

export class TravelRequestStatusChangeFormGroup extends PersistentFormGroup<{
    newStatusId: PersistentFormControl<TravelRequestStatus | null>;
    additionalInfo: PersistentFormControl<string>;
}> {
    constructor() {
        super({
            newStatusId: new PersistentFormControl<TravelRequestStatus | null>(null, {
                validators: [Validators.required],
            }),
            additionalInfo: new PersistentFormControl<string>('', {
                validators: maxLengthValidator(500),
            }),
        });
    }
}
